// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"44954e06","668":"f838927b","785":"19ceb0c0"}[chunkId] + ".js";
};